<div class="flex flex-col items-center justify-center text-center">

    <!-- Sezione conferma emissione -->
  <div class="mb-6">
    <h2 class="mb-4">La tua polizza è stata emessa, procedi con la firma</h2>
    <p>La tua polizza è stata emessa correttamente, ora devi firmare i documenti</p>
  </div>

  <!-- Sezione Errore -->
  <div *ngIf="!loading && errore" class="border border-red-300 bg-red-50 rounded-lg p-4 shadow mb-6">
    <h3 class="text-lg text-red-500 mb-4">Errore nel recupero dei documenti di polizza!</h3>
    <p class="text-red-500 mb-6">{{ errore }}</p>
    <button
      class="bg-red-400 text-white font-semibold px-4 py-2 rounded shadow hover:bg-red-700 disabled:opacity-50"
      (click)="startPolling()"
    >
      Riprova
    </button>
  </div>

  <!-- Loader -->
  <div *ngIf="loading" 
      class="mb-6 flex flex-col items-center justify-center text-gray-700 font-medium text-center">
    <svg class="animate-spin h-16 w-16 text-blue-500 mb-3"
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10"
              stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
    </svg>
    <div class="text-gray-600 mt-2">
      <h3 class="mb-2">Caricamento documenti di polizza</h3>
      <p>Stiamo creando i documenti digitali, l'operazione potrebbe richiedere qualche minuto</p>
    </div>
  </div>

  <div *ngIf="!loading && signLink" class="mb-6">
    <!-- In caso di pagamento con SDD -->
    <div *ngIf="metodoPagamento==='SDD'" class="text-gray-600 mb-6">
      <h2>Procedi con la firma dei documenti</h2>
      <p>Clicca sul bottone "Firma Ora" si aprirà una nuova finestra dove potrai visionare i documenti di polizza e firmarli.</p>
      <p>Il pagamento verrà verificato tramite la banca nei prossimi giorni.</p>
      <button
        class="mt-6 bg-green-600 text-white font-semibold px-6 py-2 rounded shadow hover:bg-green-700"
        (click)="firmaPolizza()"
      >
        Firma Ora
      </button>
    </div>

    <!-- In caso di pagamento con Carta di Credito/Debito -->
    <div *ngIf="metodoPagamento==='EXTERNAL_PROVIDER' && emissione?.redirectUrl" class="text-gray-600 mb-6">
      <h2>IMPORTANTE: Non chiudere questa finestra</h2>
      <h3>Sarà necessario ritornarci per effettuare il pagamento con carta di credito/debito</h3>
      <p>Clicca sul bottone "Firma Ora", si aprirà una nuova finestra dove potrai visionare i documenti di polizza e firmarli.</p>
      <p>Poi ritorna su questa finestra per effettuare il pagamento".</p>
      <button
        class="mt-6 bg-green-600 text-white font-semibold px-6 py-2 rounded shadow hover:bg-green-700"
        (click)="firmaPolizza()"
      >
        Firma Ora
      </button>
    </div>
    <div *ngIf="metodoPagamento=='EXTERNAL_PROVIDER' && emissione?.redirectUrl" class="text-gray-600 mb-6">
      <h2>Effettua il pagamento SOLO dopo aver completato la firma</h2>
      <p>Clicca sul bottone "Paga Ora", si aprirà una nuova finistra dove potrai effettuare il pgamento con carta di credito/debito.</p>
      <button
        class="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded shadow hover:bg-blue-700"
        (click)="vaiAlPagamento()"
      >
        Paga Ora
      </button>
    </div>
  </div>

</div>
